import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { primeIcon } from "../../icon";
import styles from "../empty-state.module.scss";
import { useEmptyStateContext } from "../empty-state.context";
import type { EmptyStateActionProps } from "../types-empty-state";

/** Botão `secondary` preenchido do tema Prime (Figma 7393:142202: surface/100, texto surface/600, 112×35). */
export function EmptyStateAction({ label, icon, className, ...rest }: EmptyStateActionProps) {
  const { partTestId, classNames: parts } = useEmptyStateContext();

  return (
    <Button
      type="button"
      severity="secondary"
      label={label}
      icon={icon ? primeIcon(icon, 14) : undefined}
      className={classNames(styles.action, parts.action, className)}
      data-testid={partTestId("action")}
      {...rest}
    />
  );
}
EmptyStateAction.displayName = "EmptyState.Action";
